import MyEntityStar from './MyEntityStar'
import * as actions from './my-entity-star-actions'
import * as constants from './my-entity-star-constants'
import reducer from './my-entity-star-reducer'
import saga from './my-entity-star-saga'

export {MyEntityStar, actions, constants, reducer, saga}
export default MyEntityStar
